/** @module app.test.pages */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';

@autoinject
export class TestEssDaterange extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    protected startDate: string | null = null;
    protected endDate: string | null = null;
    protected readonly: boolean = false;
    protected placeholder: string | null = null;

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    //constructor(...rest: any[]) { super(...rest); }
    //protected async activate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {}
    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }



    ////****************** Events ***************************************************////

    protected toggleReadonly() {
        this.readonly = !this.readonly;
    }

    protected changeStartDate(value: string | null): void {
        this.startDate = value;
    }

    protected changeEndDate(value: string | null): void {
        this.endDate = value;
    }

    protected changeRange(start: string | null, end: string | null): void {
        this.startDate = start;
        this.endDate = end;
    }

    protected changePlaceholder(value: string | null): void {
        this.placeholder = value;
    }

    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////

}
